module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid email")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [(!_vm.sent) ? _c('form', {
    attrs: {
      "name": "formregister"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendForgot($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "100",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Reset Password",
      "name": "submitButton"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.sent) ? _c('div', [_c('p', [_vm._v("Password reset successfully. ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Enter Email: "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Please check your email for your new password. The password can be changed in the my account section after logging in with your new password. "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log in.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca75ad4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ForgotPassword.vue
// module id = 281
// module chunks = 1